import styled from 'styled-components'

export const Section = styled.section`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	min-height: 80vh;
	width: 100%;
	padding-top: 140px;
	padding-bottom: 120px;
`

export const Title = styled.h1`
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	font-family: 'AkiraExpanded', sans-serif;
	font-style: normal;
	font-weight: 800;
	font-size: 80px;
	line-height: 88px;
	color: #fff;
	text-transform: uppercase;

	@media (max-width: 992px) {
		font-size: 56px;
		line-height: 64px;
	}
`

export const Paragraph = styled.p`
	font-family: 'Roboto Mono', sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 21px;
	color: #4f4f4f;
`

export const ButtonHighlight = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	font-family: 'Roboto Mono', sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	color: #fff;
	text-align: center;

	&:before {
		position: absolute;
		width: 100%;
		height: 15px;
		margin-top: 5px;
		margin-left: -10px;
		z-index: -1;
		content: '';
		background-color: #eb1c24;
		transform: rotate(-2deg);
	}
`

export const HomeBackground = styled.div`
	position: fixed;
	top: 0;
	width: 100vw;
	min-height: 100vh;
	z-index: -10;
	background: url('/images/sevens_turner_bg_s.jpg') no-repeat center center;
	background-size: cover;

	@media (min-width: 768px) {
		background-image: url('/images/sevens_turner_bg_m.jpg');
	}

	@media (min-width: 1024px) {
		background-image: url('/images/sevens_turner_bg_l.png');
	}

	@media (min-width: 1200px) {
		background-image: url('/images/sevens_turner_bg_xl.jpg');
	}
`

export const VideoWrapper = styled.div`
	position: relative;
	padding-top: ${(props) => 100 / (props.width / props.height)}%;

	.react-player {
		position: absolute;
		top: 0;
		left: 0;
	}
`

export const VideoContainer = styled.div`
	width: 90%;
	max-width: 900px;
`

export const Image = styled.div`
	position: sticky;
	bottom: 0;
	margin-top: auto;

	img {
		//position: absolute;
		//top: 0;
		//left: -50%;
		width: 200%;
		max-width: initial;
		margin-left: -50%;
	}
`

export const ImageDojo = styled.div`
	width: 100%;
`

export const Footer = styled.div`
	padding: 64px 0 64px 0;
	width: 100%;
	height: 100%;
	background-color: black;
	color: white;
`
